import { BrowserRouter, Route, Routes } from "react-router-dom";
import Dashboard from "./pages/Dashboard";
import Main from "./components/Main";
import { Toaster } from "react-hot-toast";
import User from "./pages/User";
import LoginPage from "./pages/LoginPage";
// import Unauth from "./pages/Unauth";
// import Page404 from "./pages/Page404";
import Loader from "./components/Loader";
import Orders from "./pages/Order";
import Category from "./pages/Category";
import Timeslots from "./pages/Timeslots";
import Services from "./pages/Services";
import SubCategory from "./pages/SubCategory";
import Type from "./pages/Type";
import MostBooked from "./pages/MostBooked";
import CorporateEnquiry from "./pages/CorporateEnquiry";
import Banner from "./pages/Banner";
import Apoinment from "./pages/Apoinment";
import Employee from "./pages/Employee";
import Vendor from "./pages/Vendor";
import ProtectedRoute from "./components/ProtectedRoute";
import RoleRoute from "./routes/RoleRoute";
import { AuthProvider } from "./context/AuthProvider";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Loader />
<Routes>
  <Route path="/login" element={<LoginPage />} />

  {/* LOGIN REQUIRED */}
  <Route element={<ProtectedRoute />}>
    <Route path="/" element={<Main />}>
      <Route index element={<Dashboard />} />

      {/* ADMIN ONLY */}
      <Route element={<RoleRoute allowedRoles={["admin"]} />}>
        <Route path="users" element={<User />} />
        <Route path="timeslots" element={<Timeslots />} />
        <Route path="most-booked" element={<MostBooked />} />
        <Route path="banner" element={<Banner />} />
        <Route path="emp" element={<Employee />} />
        <Route path="vendors" element={<Vendor />} />
      </Route>

      {/* ADMIN + VENDOR (PRODUCTS, SERVICES & CATALOG) */}
      <Route element={<RoleRoute allowedRoles={["admin", "vendor"]} />}>
        <Route path="services" element={<Services />} />
        <Route path="categorys" element={<Category />} />
        <Route path="categorys/:id" element={<SubCategory />} />
        <Route path="types/:id" element={<Type />} />
      </Route>

      {/* ADMIN + EMPLOYEE (OPERATIONS & ENQUIRIES) */}
      <Route element={<RoleRoute allowedRoles={["admin", "employee"]} />}>
        <Route path="apoinment" element={<Apoinment />} />
        <Route path="Co-enquiry" element={<CorporateEnquiry />} />
      </Route>

      {/* ADMIN + EMPLOYEE + VENDOR (ORDERS) */}
      <Route element={<RoleRoute allowedRoles={["admin", "employee", "vendor"]} />}>
        <Route path="orders" element={<Orders />} />
      </Route>

    </Route>
  </Route>
</Routes>


        <Toaster position="top-right" reverseOrder={false} />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
